import ExcelJS from 'exceljs'
import type { SalariesReportResponse } from '../types/reports.types'

export async function exportSalariesToExcel(report: SalariesReportResponse): Promise<void> {
  const workbook = new ExcelJS.Workbook()
  workbook.creator = 'TCO Admin'
  workbook.created = new Date()

  const sheet = workbook.addWorksheet(`Зарплаты ${report.meta.period}`)

  // Title row
  sheet.mergeCells('A1:K1')
  const titleCell = sheet.getCell('A1')
  titleCell.value = `Зарплаты сотрудников за ${report.meta.period}`
  titleCell.font = { bold: true, size: 14 }
  titleCell.alignment = { horizontal: 'center' }
  sheet.getRow(1).height = 22

  // Header row
  sheet.getRow(3).values = [
    '#',
    'Сотрудник',
    'Таб. №',
    'Организация',
    'Подразделение',
    'Должность',
    'Оклад, ₸',
    'Бонусы, ₸',
    'Удержания, ₸',
    'К выплате, ₸',
    'Источник бонусов',
  ]
  const headerRow = sheet.getRow(3)
  headerRow.eachCell((cell) => {
    cell.font = { bold: true }
    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE2E8F0' },
    }
    cell.border = {
      top: { style: 'thin' },
      bottom: { style: 'thin' },
      left: { style: 'thin' },
      right: { style: 'thin' },
    }
  })
  headerRow.height = 30

  // Column widths
  sheet.getColumn(1).width = 6
  sheet.getColumn(2).width = 32
  sheet.getColumn(3).width = 14
  sheet.getColumn(4).width = 26
  sheet.getColumn(5).width = 22
  sheet.getColumn(6).width = 22
  sheet.getColumn(7).width = 14
  sheet.getColumn(8).width = 14
  sheet.getColumn(9).width = 14
  sheet.getColumn(10).width = 16
  sheet.getColumn(11).width = 18

  // Data rows
  let rowIdx = 4
  report.data.forEach((rec, i) => {
    const row = sheet.getRow(rowIdx)
    row.values = [
      i + 1,
      rec.employee_name,
      rec.employee_number || '',
      rec.organization_name || '',
      rec.department_name || '',
      rec.position_name || '',
      rec.amount,
      rec.bonuses,
      rec.deductions,
      rec.net_amount,
      rec.synced_from_kpi ? 'KPI sandyq.kz' : rec.is_missing ? 'нет данных' : '',
    ]

    // Money columns format
    for (let col = 7; col <= 10; col++) {
      row.getCell(col).numFmt = '#,##0'
    }
    // К выплате — bold
    row.getCell(10).font = { bold: true }

    // Missing-data row styling
    if (rec.is_missing) {
      row.eachCell((cell) => {
        cell.font = { ...(cell.font || {}), color: { argb: 'FF888888' } }
      })
    }

    row.eachCell((cell) => {
      cell.border = {
        top: { style: 'hair' },
        bottom: { style: 'hair' },
        left: { style: 'hair' },
        right: { style: 'hair' },
      }
    })

    rowIdx++

    // Breakdown sub-rows (if any)
    if (rec.bonuses_breakdown.length > 0) {
      for (const b of rec.bonuses_breakdown) {
        const subRow = sheet.getRow(rowIdx)
        subRow.getCell(2).value = `   ↳ ${b.organization} · ${b.department}`
        subRow.getCell(8).value = b.sum
        subRow.getCell(8).numFmt = '#,##0'
        subRow.eachCell((cell) => {
          cell.font = { italic: true, color: { argb: 'FF666666' } }
        })
        rowIdx++
      }
    }
  })

  // Totals row
  const totalsRow = sheet.getRow(rowIdx)
  totalsRow.values = [
    '',
    'Итого',
    '',
    '',
    '',
    '',
    report.meta.totals.amount,
    report.meta.totals.bonuses,
    report.meta.totals.deductions,
    report.meta.totals.net_amount,
    '',
  ]
  totalsRow.eachCell((cell) => {
    cell.font = { bold: true }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFF1F5F9' },
    }
    cell.border = {
      top: { style: 'medium' },
      bottom: { style: 'medium' },
      left: { style: 'thin' },
      right: { style: 'thin' },
    }
  })
  for (let col = 7; col <= 10; col++) {
    totalsRow.getCell(col).numFmt = '#,##0'
  }

  // Freeze header
  sheet.views = [{ state: 'frozen', ySplit: 3 }]

  // Download
  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `salaries_${report.meta.period}.xlsx`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
